var matcheHeightInit;

(function ($) {

	const selectors = {
		elem: '[data-mh]',
	}

	matcheHeightInit = function () {
		$(selectors.elem).matchHeight();
	}

})(jQuery);


export default matcheHeightInit;